import React, { useEffect } from "react";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import "../disclaimer/disclaimer.css";

import { ReactComponent as QuatesIcon } from "../../assets/Objects.svg";
import { Avatar } from "@mantine/core";
import avatar from "../../assets/avatar.png";
import { Rating } from "@mantine/core";

const ReviewPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const testimonials = [
    {
      name: "Yossi M.",
      designation: "Lakewood, NJ",
      message:
        "Our flight from Europe was canceled last minute due to airline scheduling issues. I submitted a claim through Fly n’ Claim, and they handled the entire process. We received over €500 per passenger — no stress, no chasing. It was smooth, quick, and very professional.",
    },
    {
      name: "Miriam R.",
      designation: "London, UK",
      message:
        "I wasn’t sure I’d qualify for compensation after my flight from New York arrived more than 4 hours late. Fly n’ Claim made everything so easy. They explained the process clearly, kept me updated, and I had the money in my account in just a few weeks. I’ve already recommended them to friends.",
    },
    {
      name: "Kevin S.",
      designation: "Los Angeles, CA",
      message:
        "After being denied boarding due to an overbooked flight, I decided to try Fly n’ Claim. They were fast, professional, and took care of all the paperwork. I didn’t have to deal with the airline at all. Highly recommended!",
    },
    {
      name: "Sarah K.",
      designation: "Haifa, Israel",
      message:
        "My baggage was delayed for two full days after a long international flight. I submitted my info online and Fly n’ Claim took care of the rest. I got reimbursed for my expenses and received the full compensation I was entitled to — no hassle and great communication throughout.",
    },
    {
      name: "Michael T.",
      designation: "Zurich, Switzerland",
      message:
        "We had a missed connection due to a delay on the first leg of our journey. A friend told me about Fly n’ Claim, and I’m glad they did. The whole process was simple and they got us paid quickly. It couldn’t have been easier.",
    },
    {
      name: "Rose C.",
      designation: "Frequent Flyer",
      message:
        "We were traveling with two toddlers and were denied boarding due to overbooking. It was a nightmare, but Fly n’ Claim made sure we were compensated quickly.",
    },
    {
      name: "Avi S.",
      designation: "Brooklyn, NY",
      message:
        "After a 4-hour delay, I used Fly n’ Claim to submit a case. They were fast, professional, and took care of all the paperwork. I didn’t have to deal with the airline at all. Highly recommended!",
    },
  ];
  return (
    <div className="disclaimer-page-wrapper">
      <Nav />
      <div style={{ marginTop: "50px" }}>
        <div className="disclaimer-wrapper">
          <div className="disclaimer-text-wrapper">
            {/* <h5 className="sub-header-red">Info and Privacy</h5> */}
            <h3 className="header">Reviews</h3>
            <h6 className="sub-header text-center" style={{ width: "48%" }}>
              What our Clients Say About Us
            </h6>
          </div>
          <div className="disclaimer-summary-wrapper">
            <div className="reviews-wrapper"></div>
            {testimonials.map((testimonial, index) => {
              return (
                <div key={index} className="review-box">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px",
                      padding: "30px",
                      backgroundColor: "#f4f4f431",
                      borderRadius: "24px",

                      marginBottom: "30px",
                    }}
                  >
                    <QuatesIcon />
                    <p className="sub-header">{testimonial.message}</p>
                    <div className="user-review-wrapper">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Avatar size={"lg"} alt="its me" />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <span style={{ fontWeight: "700" }}>
                            {testimonial.name}
                          </span>
                          <span style={{ fontWeight: "400" }}>
                            {testimonial.designation}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Rating defaultValue={5} />
                        <span>5.0</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ReviewPage;
